module.exports = __webpack_public_path__ + "img/location.b47dbf71.svg";